import $ from 'jquery';
import * as YandexLoader from 'ymaps';
import moment from 'moment';

import {toCurrency, Cache, deliveryDate, toCashback} from '../utilities';
import {basketUpdate, deliveryOrder, deliverySave, orderPickpoints} from '../queries';
import {changeObjectKeys} from '../utilities';
import lodash, {isSet} from "lodash";

// if('/order/' === window.location.pathname){
//     const userType = $('[name="user-promotion"]').val();
//     if (userType==3){
//         $('.page-order-delivery-type').hide().find('[data-required]').prop('required', false);
//         $(`.page-order-delivery-type--courier`).show().find('[data-required]').prop('required', true);
//         $('.page-order').trigger('calculate');
//     }
// }
let previousPlacemark;
(function () {

    $('.ui-radio-beauty-item__control[name="delivery_type"]').change(function () {
        const value = $(this).val();
        $('.page-order-delivery-type').hide().find('[data-required]').prop('required', false);
        $(`.page-order-delivery-type--${value}`).show().find('[data-required]').prop('required', true);
        $('.page-order').trigger('calculate');
    });

    $(document).on('prices-updated', function () {
        $('.page-order').trigger('calculate');
        $('.page-order').removeClass('page-order--loading');
    });

    $('.page-order').on('calculate', function () {
        let totalBasePrice = 0;
        let totalPrice = 0;
        let totalPriceLevel2 = 0;
        let totalDiscount = 0;
        let totalCashback = 0;
        let totalCashbackSpend = 0;

        const itemsDeleted = [];

        $('.ui-product-simple').each(function () {
            const OrderNotAvailable = async () => {
                const $component = $(this);
                const productId = $component.attr('data-product-id');

                $component.remove();
                $('.page-basket').trigger('calculate');

                const response = await basketUpdate(productId, 0);
                $('.header-basket').replaceWith(response.component);
            };
            const $price = $(this).find('.ui-value--product-price');

            const price = +$price.attr('data-price');
            const priceBase = +$price.attr('data-price-base');
            const priceLevel2 = +$price.attr('data-price-level-2');
            const discount = +$price.attr('data-discount');
            const quantity = +$(this).attr('data-quantity');
            const cashback = +$price.attr('data-cashback');

            if (!$price.attr('data-price')) {
                const name = $(this).find('.ui-product-simple__name').text().trim();
                if  (!itemsDeleted.includes(name)){
                    itemsDeleted.push(name);
                    OrderNotAvailable();
                }
                // $(this).hide();
                return;
            }

            totalBasePrice   += priceBase   * quantity;
            totalPrice       += price       * quantity;
            totalDiscount    += discount    * quantity;
            totalPriceLevel2 += priceLevel2 * quantity;
            totalCashback += cashback * quantity;

            $(this).find('.ui-product-simple__total').text(toCurrency(price * quantity));
        });

        if (isNaN(totalBasePrice)) {
            return;
        }

        const deliveryType = $('[name="delivery_type"]:checked').val();
        const userType = $('[name="user-promotion"]').val();

        let deliveryPrice = deliveryType === 'courier' ? 500 : 290;
        $('.ui-radio-beauty-item').first().find('b').text(toCurrency(290));
        totalCashbackSpend = parseInt($('.page-order-checkout__cashback--current').find('input[name=bonuses_pay_amount]').val())
        const totalPriceForDelivery = totalPrice + totalCashbackSpend;
        if (deliveryType !== 'courier' && totalPriceForDelivery >= 3000) {
            $('.ui-radio-beauty-item').first().find('b').text('бесплатно');
            deliveryPrice = 0;
        }
        if (totalPriceForDelivery >= 3000){
            $('.ui-radio-beauty-item').first().find('b').text(` бесплатно`);
        }
//        return true when promoaction start
//         let freeDelivery = false;
//         if (userType==='3' && totalPrice >= 5000 && freeDelivery===true){
//             $('.ui-radio-beauty-item').slice(1).find('b').text(` бесплатно`);
//             deliveryPrice = 0;
//         }

        $('.page-order-checkout__value--base b').text(toCurrency(totalBasePrice));
        $('.page-order-checkout__value--discount b').text(toCurrency(totalDiscount));
        $('.page-order-checkout__value--delivery b').text(toCurrency(deliveryPrice));
        $('.page-order-checkout__total b').text(toCurrency(totalPrice + deliveryPrice));
        if (totalCashback){
            $('.page-order-checkout__cashback--award b').text(Math.ceil(totalCashback));
        }

        $('.page-order-checkout__inner').show();

        const featuredDiscount = totalPrice - totalPriceLevel2;
        if (featuredDiscount > 0) {
            $('.page-basket-feature__title span').first().text(Math.floor(featuredDiscount));
            $('.page-basket-feature').show();
        } else {
            $('.page-basket-feature').hide();
        }

        if (itemsDeleted.length > 0) {
            const names = itemsDeleted.join(', ');
            setTimeout(() => {
                $('.js-basket-products-not-available-items').text('');
                $('.js-basket-products-not-available-items').text(`Некоторых товаров в вашей корзине нет в наличии, они будут удалены из вашей корзины: ${names}`);
                $(`.ui-modal[data-name="basket-products-not-available"]`).trigger('show');
            }, 10);
        }
    });

    $(document).on('click', '.page-order-map__select', function () {
        $('.page-order-map__overlay').hide();
    });

    $(document).on('click', '.page-order-pickpoint__reselect', function () {
        $('.page-order-map').removeClass('page-order-map--selected');
        $('[name="delivery_pickpoint"]').val('');
    });

    $('[name="delivery_pickpoint"]').focus(function () {
        if ($(this).val()) {
            $(this)[0].setCustomValidity('');
        } else {
            $(this)[0].setCustomValidity('Выберите пункт выдачи');
        }
        $(this).blur();
    });

    const orderMapItemSelect = (marker) => {
        $('.page-order-map').addClass('page-order-map--selected');
        $('[name="delivery_pickpoint"]').val(marker.name).trigger('keyup');
        $('[name="delivery_pvz_id"]').val(marker.id);
        $('[name="delivery_pvz_type"]').val(marker.type);
        $('[name="delivery_pvz_address"]').val(marker.address);

        $('.page-order-pickpoint__title').text(marker.name);
        $('.page-order-pickpoint__address').text(marker.address);
        $('.page-order-pickpoint__worktime').text(marker.worktime);
        // $('.page-order-pickpoint__value span').text(moment().add(7, 'days').format('D MMMM'));
        $('.page-order-pickpoint')
            .removeClass('page-order-pickpoint--cdek')
            .removeClass('page-order-pickpoint--post')
            .removeClass('page-order-pickpoint--artlife')
            .addClass(`page-order-pickpoint--${marker.type}`);
    };

    $(document).on('click', '.page-order-map-item__select', async function () {
        const marker = JSON.parse($(this).attr('data-marker'));

        if (marker.worktime == null) {
            marker.worktime = '';
        } else {
            marker.worktime = marker.worktime.toString()
        }
        const deliveryInfo = {
            'delivery_courier_address': marker.address,
            'delivery_kind': 'pickpoint',
            'delivery_worktime': marker.worktime,
            'delivery_pickpoint_type': marker.type,
            'delivery_courier_operation_type': 'add',
            'delivery_name': marker.name,
            'delivery_pvz_id': marker.id
        }
        const response = await deliverySave(deliveryInfo);
        deliveryDate(marker.periodMin,marker.periodMax);
        orderMapItemSelect(marker);

        Cache.set('orderMapMarker', marker, 360000);
    });

    const yandex = {
        map: null,
        markers: {},
    };

    const updateMarkers = () => {
        const {
            map_pickpoints: mapPickpointsTypes
        } = $('.js-form-order').serializeJSON();

        yandex.map.geoObjects.removeAll();
        if (!mapPickpointsTypes) {
            return;
        }

        $('body').on('click', '.js-map-pickpoint-set', function () {
            const lat = $(this).data('lat');
            const long = $(this).data('lng');
            yandex.map.setCenter([lat, long]);
            if (previousPlacemark) {
                // Удаление предыдущей метки с карты
                yandex.map.geoObjects.remove(previousPlacemark);
            }

            const placemark = previousPlacemark = new ymaps.Placemark([lat, long], {}, {
                iconLayout: 'default#image',
                iconImageSize: [40, 45],
                iconImageHref: `/local/templates/artlife/assets/img/order/placemark-point.svg`,
                iconImageOffset: [-20, -27],
                zIndex: 300
            });
            placemark.options.set('className', 'custom-placemark');
            placemark.options.set('className', 'custom-placemark--less-index');
            yandex.map.geoObjects.add(placemark);
            // Устанавливаем зум
            yandex.map.setZoom(17);
        });
        let selectedPickpoint = $('.page-order-pickpoint').find('.page-order-pickpoint__title');
            if (selectedPickpoint.length>0){
                selectedPickpoint = selectedPickpoint.html().trim();
            }else{
                deliveryDate()
            }
        mapPickpointsTypes.forEach(type => {

            yandex.markers[type].forEach(marker => {
                const conf = {
                    iconLayout: 'default#imageWithContent',
                    iconImageHref: `/local/templates/artlife/assets/img/order/pickpoint-${marker.type}.png`,
                    iconImageSize: [35, 50],
                    iconImageOffset: [-20, -50], // iconContentOffset: [300, 300],
                }
                let workTime = '';
                if (marker.worktime && marker.worktime !== null) {
                    if (Array.isArray(marker.worktime)) {
                        marker.worktime.map((element) => {
                            workTime += '<div className="page-order-map-item__worktime">' + element + '</div>'
                        });
                    } else if (typeof marker.worktime === 'string') {
                        workTime = '<div className="page-order-map-item__worktime">' + marker.worktime + '</div>'
                    }
                }
                const markerJson = JSON.stringify(marker);
                marker.period_min = marker.periodMin;
                marker.period_max = marker.periodMax;
                if (selectedPickpoint !== undefined && selectedPickpoint == $.trim(marker.name)){
                    deliveryDate(marker.period_min,marker.period_max);
                    //$('.js-delivery-date').html(`${marker.period_min} — ${marker.period_max}`)
                }
                if (marker.likedAddress) {
                    const markerPickpointJson = JSON.stringify({
                        ...marker,
                        name: marker.pickpointName,
                        id: marker.likedAddress
                    });
                    yandex.map.geoObjects.add(new ymaps.Placemark([marker.lat, marker.lng], {
                        balloonContent: `
        <div class="page-order-map-item page-order-map-item--multiple page-order-map-item-liked-${marker.likedAddress}">
            <div class="page-order-map-item__inner">
                <div class="page-order-map-item__tab page-order-map-item__tab-1">
                    <div class="page-order-map-item__title">${marker.name}</div>
                    ${marker.placetype ? `<div class="page-order-map-item__address">${marker.placetype}</div>` : ''}
                             ${marker.period_min && marker.period_max ? `
                        <div class="page-order-map-item__delivery-time">
                            Расчетное время доставки: от ${marker.period_min} до ${marker.period_max} дней
                        </div>
                    ` : ''}
                    <div class="page-order-map-item__address">${marker.address}</div>
                    ${workTime}
                    <div class="ui-button ui-button--small page-order-map-item__select" data-marker='${markerJson}' data-delivery-type="PICKPOINT">
                        Выбрать
                    </div>
                </div>
                </br>
                <div class="page-order-map-item__tab page-order-map-item__tab-2">
                    <div class="page-order-map-item__title">${marker.pickpointName}</div>
                    ${marker.pickpointType ? `<div class="page-order-map-item__address">${marker.pickpointType}</div>` : ''}
                    <div class="page-order-map-item__address">${marker.address}</div>
                    ${workTime}
                    <div class="ui-button ui-button--small page-order-map-item__select" data-marker='${markerPickpointJson}' data-delivery-type="PICKPOINT">
                        Выбрать
                    </div>
                </div>
            </div>

        </div>
    `,
                    }, conf));

                } else {
                    yandex.map.geoObjects.add(new ymaps.Placemark([marker.lat, marker.lng], {
                        balloonContent: `
                    <div class="page-order-map-item">
                        <div class="page-order-map-item__inner">
                            <div class="page-order-map-item__title">${marker.name}</div>
                            ${marker.placetype ? `<div class="page-order-map-item__address">${marker.placetype}</div>` : ''}
                                               ${marker.period_min && marker.period_max ? `
                        <div class="page-order-map-item__delivery-time">
                            Расчетное время доставки: от ${marker.period_min} до ${marker.period_max} дней
                        </div>
                    ` : ''}
                            <div class="page-order-map-item__address">${marker.address}</div>
                            ${workTime}
                            <div class="ui-button ui-button--small page-order-map-item__select" data-marker='${markerJson}' data-delivery-type="PICKPOINT">
                                Выбрать
                            </div>
                        </div>
                    </div>
                `,
                    }, conf));
                }

            });
        });

    };

    $('[name="map_pickpoints[]"]').change(updateMarkers);

    if (window.location.pathname.indexOf('/order') === -1) {
        return;
    }

    YandexLoader.default.load('https://api-maps.yandex.ru/2.1/?apikey=08c8d65a-b50d-4915-97ad-f06875a6d428&lang=ru_RU')
        .then(async function (ymaps) {
            if ($('.page-order-map__map').length === 0) {
                return;
            }
            window.ymaps = ymaps;
            ymaps.ready(async function () {
                const response = await orderPickpoints();
                yandex.map = new ymaps.Map('page-order-map__map', {
                    center: [response.geo.lat, response.geo.lng], zoom: 13, controls: ['zoomControl']
                });
                yandex.markers = response.items;
                updateMarkers();

                $('.page-order-map').addClass('page-order-map--loaded');
            });
        });
    $(document).ready(function () {
        $('.page-order-map').removeClass('page-order-map--selected');
        $('[name="delivery_pickpoint"]').val('');
    });
}());


(async function () {
    if ($('.page-order-panel').length === 0) {
        return;
    }
    const response = await deliveryOrder();
    $('.page-order-form__delivery-items').html(response.component).removeClass('page-personal-delivery__items--loading');
    let error = false;
    $('h2').map(function () {
        if ($(this).text() === 'Адреса доставки не найдены') {
            error = true
        }
    })
    if (error) {
        $('.page-personal-delivery-form').fadeIn()
    }
    const $form = $('.js-page-order-panel__hidden-delivery-form');
    const params = changeObjectKeys(response.mainAddress, lodash.snakeCase)
    if (response.mainAddress) {
        $form.find('input').val(function ()
        {
            // if (this.name === 'comment') {
            //     return params['delivery_courier_comment']['value'];
            // }
            if (params[this.name]!== undefined){
                return params[this.name]['value'];
            }
        });
    }
    $('.ui-scroll').each(function () {
        $(this).trigger('init');
    });
})();
(async function () {
    $('.ui-scroll').each(function () {
        $(this).trigger('init');
    });
})();
